export default __webpack_public_path__ + "static/media/death.ffea29f9.jpg";